const minutesToDurationString = (timeInMinutes: number) => {
  let minutes = timeInMinutes % 60
  let hours = Math.floor(timeInMinutes / 60)

  if (timeInMinutes < 60) {
    return `${minutes}m`
  } else if (minutes === 0) {
    return `${hours}h`
  } else {
    return `${hours}h ${minutes}m`
  }
}

export default minutesToDurationString